"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgrammaticReservationCancellationDto = exports.ProgrammaticExposureAuthorizationDto = void 0;
const class_validator_1 = require("class-validator");
const programmatic_type_1 = require("../../types/programmatic.type");
class ProgrammaticExposureAuthorizationDto {
    displayId;
    reservationKey;
    deliveryId;
    mediaId;
    instanceId;
    occurrenceId;
    playerProtocolVersion;
    capabilities;
}
exports.ProgrammaticExposureAuthorizationDto = ProgrammaticExposureAuthorizationDto;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], ProgrammaticExposureAuthorizationDto.prototype, "displayId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(128),
    __metadata("design:type", String)
], ProgrammaticExposureAuthorizationDto.prototype, "reservationKey", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(200),
    __metadata("design:type", String)
], ProgrammaticExposureAuthorizationDto.prototype, "deliveryId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(200),
    __metadata("design:type", String)
], ProgrammaticExposureAuthorizationDto.prototype, "mediaId", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    __metadata("design:type", String)
], ProgrammaticExposureAuthorizationDto.prototype, "instanceId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(300),
    __metadata("design:type", String)
], ProgrammaticExposureAuthorizationDto.prototype, "occurrenceId", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(2),
    (0, class_validator_1.Max)(2),
    __metadata("design:type", Number)
], ProgrammaticExposureAuthorizationDto.prototype, "playerProtocolVersion", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayUnique)(),
    (0, class_validator_1.IsIn)([programmatic_type_1.PROGRAMMATIC_PLAYER_CAPABILITY], { each: true }),
    __metadata("design:type", Array)
], ProgrammaticExposureAuthorizationDto.prototype, "capabilities", void 0);
class ProgrammaticReservationCancellationDto {
    displayId;
    reservationKey;
    reason;
}
exports.ProgrammaticReservationCancellationDto = ProgrammaticReservationCancellationDto;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], ProgrammaticReservationCancellationDto.prototype, "displayId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(128),
    __metadata("design:type", String)
], ProgrammaticReservationCancellationDto.prototype, "reservationKey", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(200),
    __metadata("design:type", String)
], ProgrammaticReservationCancellationDto.prototype, "reason", void 0);
